module.exports = __webpack_public_path__ + "marriot-card-bottom-right.JXKHLvyg.png";